import { render, staticRenderFns } from "./popup-process-test.vue?vue&type=template&id=51a8203d&scoped=true"
import script from "./popup-process-test.vue?vue&type=script&lang=js"
export * from "./popup-process-test.vue?vue&type=script&lang=js"
import style0 from "./popup-process-test.vue?vue&type=style&index=0&id=51a8203d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a8203d",
  null
  
)

export default component.exports